<!--
  appendTo="body" es obligatorio: el modal vive dentro de .info-card, que tiene :hover{transform},
  y ese ancestro atraparía el position:fixed del diálogo. Sin dismissableMask a propósito: hay
  trabajo sin guardar (excepción de wizard del styleguide); se cierra con X o Esc, con confirmación.
-->
<p-dialog
  [(visible)]="visible"
  (onHide)="hide()"
  [modal]="true"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '1080px', maxWidth: '96vw' }"
  styleClass="edit-amounts-dialog"
>
  <!--
    Cabecera propia: la X y el Esc de PrimeNG cierran directo, saltándose la confirmación de
    descarte que sí respeta "Cancelar". Con `closable` y `closeOnEscape` apagados, las tres vías
    de salida pasan por `requestHide()` y se comportan igual.
  -->
  <ng-template pTemplate="header">
    <span class="ea-title">Editar saldos del arrendamiento</span>
    <button type="button" class="ea-close" (click)="requestHide()" aria-label="Cerrar"><i class="pi pi-times"></i></button>
  </ng-template>

  <!-- Contexto permanente: de dónde parte el arrendamiento -->
  <div class="ea-context" *ngIf="totals">
    <div class="ea-context-item">
      <span class="lbl">Valor de cartera</span><span class="val">{{ totals.walletValue | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
    </div>
    <div class="ea-context-item">
      <span class="lbl">Rentas por cobrar</span
      ><span class="val">{{ totals.rentsToCollectAmount | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
    </div>
    <div class="ea-context-item">
      <span class="lbl">Letras pendientes</span><span class="val">{{ totals.rentsToCollect }}</span>
    </div>
    <div class="ea-context-item">
      <span class="lbl">Estado</span><span class="val">{{ leaseStatus }}</span>
    </div>
  </div>

  <!-- ── 1. Qué quieres hacer ─────────────────────────────────────────── -->
  <div class="ea-step">
    <div class="ea-step-head">
      <span class="ea-step-num">1</span>
      <h4>¿Qué quieres hacer?</h4>
    </div>
    <div class="ea-ops">
      <button
        type="button"
        class="ea-op"
        *ngFor="let op of operations"
        [class.is-active]="operation === op.key"
        (click)="selectOperation(op.key)"
      >
        <i [class]="op.icon"></i>
        <span class="ea-op-title">{{ op.title }}</span>
        <span class="ea-op-hint">{{ op.hint }}</span>
      </button>
    </div>
  </div>

  <!-- ── 2. Captura ───────────────────────────────────────────────────── -->
  <div class="ea-step" *ngIf="operation">
    <div class="ea-step-head">
      <span class="ea-step-num">2</span>
      <h4>Captura del ajuste</h4>
    </div>

    <!-- EDITAR LETRAS -->
    <ng-container *ngIf="operation === 'EDIT_PERIODS'">
      <div class="ea-scope">
        <label>Qué vas a capturar</label>
        <p-selectButton
          [options]="[
            { label: 'Renta y Accesorios', value: 'RENT' },
            { label: 'Conceptos (avanzado)', value: 'CONCEPTS' },
          ]"
          [(ngModel)]="captureMode"
          (onChange)="onCaptureModeChange()"
          optionLabel="label"
          optionValue="value"
        ></p-selectButton>
      </div>

      <!-- Cómo se derivan los montos. Va antes de la captura: el operador tiene que entender qué
           va a pasar con lo que teclee, no descubrirlo en la previsualización. -->
      <div class="ea-explain" *ngIf="derivesOnServer">
        <div class="ea-explain-head">
          <i class="pi pi-calculator"></i>
          <span
            >Capturas la <strong>Renta</strong> y la <strong>mensualidad de Accesorios</strong> tal como vienen en el pagaré. La plataforma
            calcula el resto con los parámetros de este arrendamiento<span *ngIf="interestRate">
              (tasa <strong>{{ interestRate | number: '1.2-2' }}%</strong> anual)</span
            >.</span
          >
        </div>
        <ul class="ea-explain-list">
          <li>
            <strong>Interés</strong> = saldo insoluto de la letra anterior × tasa ÷ 12. Lo fija el contrato, no la renta que captures.
          </li>
          <li><strong>Capital</strong> = Renta − Interés. Es el que absorbe la corrección.</li>
          <li>
            <strong>Accesorios del mes</strong> = exactamente lo que captures. Solo se reparte entre capital y comisión; no se le suma
            interés.
          </li>
          <li><strong>IVA</strong> = 16% sobre (Renta + Accesorios del mes), salvo en lo que marques que ya lo incluye.</li>
        </ul>
        <div class="field-checkbox ea-iva">
          <p-checkbox [(ngModel)]="rentIncludesIva" [binary]="true" inputId="ea-rent-iva" (onChange)="onIncludeIvaChange()"></p-checkbox>
          <label for="ea-rent-iva">La renta que capturo <strong>ya incluye IVA</strong></label>
        </div>
        <div class="field-checkbox ea-iva">
          <p-checkbox
            [(ngModel)]="accessoriesIncludeIva"
            [binary]="true"
            inputId="ea-acc-iva"
            (onChange)="onIncludeIvaChange()"
          ></p-checkbox>
          <label for="ea-acc-iva">La mensualidad de accesorios que capturo <strong>ya incluye IVA</strong></label>
        </div>
        <small>El <strong>Pago Esperado</strong> es la suma de todo. Previsualiza para ver el desglose antes de guardar.</small>
      </div>

      <div class="ea-scope">
        <label>Alcance</label>
        <p-selectButton
          [options]="[
            { label: 'Una letra', value: 'SINGLE' },
            { label: 'Selección múltiple', value: 'MULTI' },
            { label: 'Desde una letra en adelante', value: 'CASCADE' },
          ]"
          [(ngModel)]="scope"
          (onChange)="onScopeChange()"
          optionLabel="label"
          optionValue="value"
        ></p-selectButton>
      </div>

      <div class="ea-cascade" *ngIf="scope === 'CASCADE'">
        <div class="field">
          <label for="fromPeriod">Desde la letra</label>
          <p-dropdown
            inputId="fromPeriod"
            [options]="periods"
            [(ngModel)]="fromPeriod"
            optionLabel="period"
            optionValue="period"
            placeholder="Selecciona la letra inicial"
            appendTo="body"
            (onChange)="invalidatePreview()"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
        <div class="field">
          <label>Cómo propagar el cambio</label>
          <p-selectButton
            [options]="[
              { label: 'Mismo valor en todas', value: 'SAME_VALUE' },
              { label: 'Misma diferencia en cada una', value: 'SAME_DELTA' },
            ]"
            [(ngModel)]="cascadeMode"
            (onChange)="invalidatePreview()"
            optionLabel="label"
            optionValue="value"
          ></p-selectButton>
        </div>
        <div class="warn-box ea-info" *ngIf="fromPeriod != null">
          <i class="pi pi-info-circle"></i>
          <span
            >El cambio alcanzará <strong>{{ periodsInScope.length }}</strong> letra(s). Captura la primera y el resto la sigue.<span
              *ngIf="derivesOnServer && cascadeMode === 'SAME_VALUE'"
            >
              Todas quedarán con la misma renta, pero <strong>cada una deriva su propio interés</strong> contra su saldo insoluto.</span
            ></span
          >
        </div>
      </div>

      <!-- Selector de letras (SINGLE / MULTI) -->
      <div class="ea-picker" *ngIf="scope !== 'CASCADE'">
        <label>Selecciona {{ scope === 'SINGLE' ? 'la letra' : 'las letras' }}</label>
        <div class="ea-chips">
          <button
            type="button"
            class="ea-chip"
            *ngFor="let p of periods"
            [class.is-on]="isSelected(p)"
            [class.is-covered]="isCovered(p)"
            (click)="togglePeriod(p)"
          >
            {{ p.period }}
          </button>
        </div>
      </div>

      <!-- Rejilla editable -->
      <div class="ea-grid-wrap" *ngIf="editableRows.length">
        <table class="ea-grid">
          <thead>
            <tr>
              <th>Letra</th>
              <th *ngFor="let c of capturedFields">{{ fieldLabel(c) }}</th>
              <th class="ea-derived">Pago esperado</th>
              <th>Aplicado</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of editableRows" [class.is-covered]="isCovered(p)" [class.is-invoiced]="p.activeInvoice">
              <td class="ea-period">
                {{ p.period }}
                <i class="fa-solid fa-lock ea-flag" *ngIf="isCovered(p)" pTooltip="Letra ya cubierta" tooltipPosition="top"></i>
                <i
                  class="fa-solid fa-file-invoice ea-flag is-fiscal"
                  *ngIf="p.activeInvoice"
                  [pTooltip]="'Factura emitida' + (p.invoiceUid ? ' · ' + p.invoiceUid : '')"
                  tooltipPosition="top"
                ></i>
              </td>
              <td *ngFor="let c of capturedFields">
                <p-inputNumber
                  [ngModel]="valueOf(p, c)"
                  (ngModelChange)="setValue(p, c, $event)"
                  mode="currency"
                  currency="MXN"
                  locale="es-MX"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [min]="0"
                  [inputStyle]="{ width: '100%', textAlign: 'right' }"
                ></p-inputNumber>
              </td>
              <!-- Por conceptos se enseña la suma en vivo; por renta el desglose lo trae el dryRun. -->
              <td class="ea-derived" [class.is-changed]="rentChanged(p)">
                <ng-container *ngIf="!derivesOnServer">
                  {{ computedRent(p) | currency: 'MXN' : 'symbol' : '1.2-2' }}
                  <small *ngIf="rentChanged(p)">antes {{ p.rent | currency: 'MXN' : 'symbol' : '1.2-2' }}</small>
                </ng-container>
                <ng-container *ngIf="derivesOnServer">
                  <span class="ea-pending">—</span>
                  <small>hoy {{ p.rent | currency: 'MXN' : 'symbol' : '1.2-2' }}</small>
                </ng-container>
              </td>
              <td class="ea-num">{{ p.appliedPayment | currency: 'MXN' : 'symbol' : '1.2-2' }}</td>
              <td>
                <p-tag
                  [value]="statusLabels[p.status] || p.status"
                  [severity]="
                    p.status === 'PAID' ? 'success' : p.status === 'OVERDUE' ? 'danger' : p.status === 'ANTICIPATED' ? 'info' : 'warning'
                  "
                ></p-tag>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- TERMINACIÓN ANTICIPADA -->
    <ng-container *ngIf="operation === 'EARLY_TERMINATION'">
      <div class="ea-two-col">
        <div class="field">
          <label for="termDate">Fecha de terminación</label>
          <p-calendar
            inputId="termDate"
            [(ngModel)]="terminationDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [readonlyInput]="true"
            appendTo="body"
            (onSelect)="invalidatePreview()"
            [style]="{ width: '100%' }"
          ></p-calendar>
        </div>
        <div class="field">
          <label>¿Qué pasa con el saldo pendiente?</label>
          <p-selectButton
            [options]="[
              { label: 'Condonarlo', value: 'WRITE_OFF' },
              { label: 'Dejarlo exigible fuera de cartera', value: 'KEEP_AS_RECEIVABLE' },
            ]"
            [(ngModel)]="pendingHandling"
            (onChange)="invalidatePreview()"
            optionLabel="label"
            optionValue="value"
          ></p-selectButton>
        </div>
      </div>
    </ng-container>

    <!-- CONDONAR MORA -->
    <ng-container *ngIf="operation === 'WAIVE_MORA'">
      <div class="warn-box ea-info">
        <i class="pi pi-info-circle"></i>
        <span
          >Una condonación vigente por letra: si la letra ya tiene una, primero deshazla desde la <strong>Bitácora</strong>. Dejar el monto
          vacío condona toda la mora pendiente (devengada − condonada − ya cobrada).</span
        >
      </div>

      <div class="ea-empty" *ngIf="!waiveRows.length">
        <i class="fa-solid fa-circle-check"></i>
        <span>Ninguna letra tiene mora pendiente que condonar.</span>
      </div>

      <table class="ea-grid" *ngIf="waiveRows.length">
        <thead>
          <tr>
            <th>Letra</th>
            <th class="text-right">Mora pendiente</th>
            <th class="text-right">Condonar</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of waiveRows">
            <td>{{ r.period }}</td>
            <td class="text-right">{{ r.max | currency }}</td>
            <td class="text-right">
              <p-inputNumber
                [inputId]="'waive-' + r.period"
                [ariaLabel]="'Condonar de la letra ' + r.period"
                [(ngModel)]="r.amount"
                (onInput)="invalidatePreview()"
                mode="currency"
                currency="MXN"
                locale="es-MX"
                [min]="0"
                [max]="r.max"
                [placeholder]="'Todo (' + (r.max | currency) + ')'"
              ></p-inputNumber>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <!-- CONDONAR DIFERENCIAS MENORES -->
    <ng-container *ngIf="operation === 'WRITE_OFF_RESIDUAL'">
      <div class="warn-box ea-info">
        <i class="pi pi-info-circle"></i>
        <span
          >Se condonará lo que les falte a las letras con saldo <strong>menor o igual al umbral</strong>: centavos o pesos que el cliente no
          completó. Previsualiza para ver exactamente cuáles y por cuánto.</span
        >
      </div>
      <div class="ea-threshold">
        <div class="field">
          <label for="ea-threshold">Umbral de condonación</label>
          <p-inputNumber
            inputId="ea-threshold"
            [(ngModel)]="residualThreshold"
            (ngModelChange)="invalidatePreview()"
            mode="currency"
            currency="MXN"
            locale="es-MX"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [min]="0"
            [inputStyle]="{ width: '100%' }"
          ></p-inputNumber>
          <small class="ea-derived-hint">Por omisión son $10.00, la tolerancia de saldo del sistema.</small>
        </div>
      </div>
    </ng-container>

    <!-- Disparador de la previsualización -->
    <!-- Sin mora que condonar no hay nada que previsualizar: el estado vacío lo dice. -->
    <div class="ea-preview-cta" *ngIf="!(operation === 'WAIVE_MORA' && !waiveRows.length)">
      <button
        pButton
        type="button"
        label="Previsualizar impacto"
        icon="fa-solid fa-calculator"
        class="p-button-outlined"
        [disabled]="!canPreview || previewing"
        [loading]="previewing"
        (click)="requestPreview()"
      ></button>
      <small *ngIf="!preview && !previewError">Antes de guardar tienes que ver cómo quedarían los saldos.</small>
      <small class="p-error" *ngIf="previewError">{{ previewError }}</small>
    </div>
  </div>

  <!-- Mientras corre la previsualización: la forma del paso 3 que viene. El dry-run abre una
       transacción contra Mongo y la descarta; con solo el botón girando la pantalla no decía nada. -->
  <div class="ea-step" *ngIf="previewing" aria-busy="true" aria-label="Calculando cómo quedarían los saldos">
    <div class="ea-step-head">
      <span class="ea-step-num">3</span>
      <h4>Así quedarían los saldos</h4>
    </div>
    <div class="ea-grid-wrap">
      <table class="ea-grid">
        <thead>
          <tr>
            <th *ngFor="let c of [1, 2, 3, 4]"><p-skeleton height="0.7rem" width="6rem"></p-skeleton></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of [1, 2, 3, 4]" [ngClass]="'sk-fade-' + f">
            <td *ngFor="let c of [1, 2, 3, 4]"><p-skeleton height="0.8rem" width="5rem"></p-skeleton></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ── 3. Impacto ───────────────────────────────────────────────────── -->
  <div class="ea-step" *ngIf="preview">
    <div class="ea-step-head">
      <span class="ea-step-num">3</span>
      <h4>Así quedarían los saldos</h4>
    </div>

    <!--
      El corte de la terminación: los dos lados de la decisión que el operador está tomando.
      Sin esto, "así quedarían los saldos" muestra la cartera en 0 sin decir de dónde salió.
    -->
    <ng-container *ngIf="terminationCut as cut">
      <!-- Nada pagado y nada vencido no es incumplimiento: el cobro todavía no empieza. -->
      <div class="ea-notstarted" *ngIf="notStarted(cut)">
        <i class="fa-solid fa-hourglass-start"></i>
        <div>
          <strong>Este arrendamiento todavía no empieza a cobrarse.</strong>
          <span
            >No hay pagos registrados porque ninguna letra ha vencido: las fechas de cobro siguen vigentes. Terminarlo aquí es cancelarlo
            antes del primer cobro, no liquidarlo.</span
          >
        </div>
      </div>

      <div class="ea-cut">
        <div class="ea-cut-box" [class.is-paid]="hasPaid(cut)" [class.is-none]="!hasPaid(cut)">
          <span class="ea-cut-label">
            <i class="fa-solid" [ngClass]="hasPaid(cut) ? 'fa-circle-check' : 'fa-circle-minus'"></i>
            {{ hasPaid(cut) ? 'Quedó pagado' : 'No hay nada pagado' }}
          </span>
          <span class="ea-cut-amount">{{ cut.pagado.monto | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
          <span class="ea-cut-hint">{{ paidSummary(cut) }}</span>
        </div>

        <div class="ea-cut-box" [class.is-forgiven]="cut.manejo === 'WRITE_OFF'" [class.is-receivable]="cut.manejo !== 'WRITE_OFF'">
          <span class="ea-cut-label">
            <i class="fa-solid" [ngClass]="cut.manejo === 'WRITE_OFF' ? 'fa-hand-holding-dollar' : 'fa-file-invoice-dollar'"></i>
            {{ cut.manejo === 'WRITE_OFF' ? 'Se condona' : 'Sigue exigible, fuera de cartera' }}
          </span>
          <span class="ea-cut-amount">{{ cut.pendiente.monto | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>

          <!-- Lo ya vencido y lo que aún no le toca pagar son dos cosas muy distintas -->
          <div class="ea-cut-split" *ngIf="cut.pendiente.vencidas">
            <span class="is-due" *ngIf="cut.pendiente.vencidas.letras > 0">
              <i class="fa-solid fa-triangle-exclamation"></i>
              Ya vencido: <strong>{{ cut.pendiente.vencidas.monto | currency: 'MXN' : 'symbol' : '1.2-2' }}</strong> ({{
                cut.pendiente.vencidas.letras
              }}
              letra{{ cut.pendiente.vencidas.letras === 1 ? '' : 's' }})
            </span>
            <span *ngIf="cut.pendiente.porVencer.letras > 0">
              <i class="fa-regular fa-clock"></i>
              Aún por vencer: <strong>{{ cut.pendiente.porVencer.monto | currency: 'MXN' : 'symbol' : '1.2-2' }}</strong> ({{
                cut.pendiente.porVencer.letras
              }}
              letra{{ cut.pendiente.porVencer.letras === 1 ? '' : 's' }})
            </span>
          </div>

          <span class="ea-cut-hint">
            {{ cut.pendiente.letras }} letra(s) sin pagar<ng-container *ngIf="cut.pendiente.desde != null">
              · de la {{ cut.pendiente.desde }} a la {{ cut.pendiente.hasta }}</ng-container
            >
            <br />{{
              cut.manejo === 'WRITE_OFF'
                ? 'Se perdona y la cartera queda en cero.'
                : 'Se le sigue pudiendo cobrar, pero ya no cuenta en la cartera activa.'
            }}
          </span>
        </div>
      </div>
    </ng-container>

    <div class="ea-stats">
      <div class="ea-stat" *ngFor="let t of changedTotals" [class.is-up]="t.delta > 0" [class.is-down]="t.delta < 0">
        <span class="ea-stat-label">{{ totalLabels[t.key] || t.key }}</span>
        <div class="ea-stat-row">
          <span class="ea-stat-before">{{ isMoney(t.key) ? (t.before | currency: 'MXN' : 'symbol' : '1.2-2') : t.before }}</span>
          <i class="fa-solid fa-arrow-right-long"></i>
          <span class="ea-stat-after">{{ isMoney(t.key) ? (t.after | currency: 'MXN' : 'symbol' : '1.2-2') : t.after }}</span>
        </div>
        <span class="ea-stat-delta">
          <i class="fa-solid" [ngClass]="t.delta > 0 ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
          {{ isMoney(t.key) ? (t.delta | currency: 'MXN' : 'symbol' : '1.2-2') : t.delta }}
        </span>
      </div>
      <div class="ea-no-change" *ngIf="!changedTotals.length">Los saldos del arrendamiento no cambian con este ajuste.</div>
    </div>

    <!--
      Diff por letra en tabla de columnas fijas (solo los campos que cambiaron en alguna letra).
      Como lista de pares campo-valor, con 4 conceptos la fila envolvía y se partía a media letra.
    -->
    <div class="ea-diffs" *ngIf="preview.periodDiffs?.length">
      <h5>{{ preview.periodDiffs.length }} letra(s) afectada(s)</h5>
      <div class="ea-grid-wrap">
        <table class="ea-grid ea-diff-table">
          <thead>
            <tr>
              <th class="ea-left">Letra</th>
              <th *ngFor="let c of diffColumns">{{ c.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of preview.periodDiffs">
              <td class="ea-left ea-period">{{ d.period }}</td>
              <td *ngFor="let c of diffColumns" class="ea-derived">
                <ng-container *ngIf="diffCell(d, c.key) as cell; else sinCambio">
                  <small class="ea-was">{{ c.money ? (cell.antes | currency: 'MXN' : 'symbol' : '1.2-2') : cell.antes }}</small>
                  <span class="ea-now">{{ c.money ? (cell.despues | currency: 'MXN' : 'symbol' : '1.2-2') : cell.despues }}</span>
                </ng-container>
                <ng-template #sinCambio><span class="ea-unchanged">—</span></ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Cómo queda el arrendamiento: solo si la operación le cambia el estado -->
    <app-lease-status-change [before]="preview.leaseOutcome?.before" [after]="preview.leaseOutcome?.after"></app-lease-status-change>

    <!-- Advertencias: cada una se confirma por separado -->
    <div class="ea-warnings" *ngIf="preview.warnings?.length">
      <div class="paid-warn" *ngFor="let w of preview.warnings">
        <div class="paid-warn-head">
          <i class="pi" [ngClass]="w.blocking ? 'pi-exclamation-circle' : 'pi-info-circle'"></i>
          <div class="paid-warn-text">
            <strong *ngIf="warningLabels[w.code] as titulo">{{ titulo }}</strong>
            <span>{{ w.message }}</span>
          </div>
        </div>
        <div class="field-checkbox" *ngIf="w.blocking">
          <p-checkbox [(ngModel)]="confirmations[w.code]" [binary]="true" [inputId]="'warn-' + w.code"></p-checkbox>
          <label [for]="'warn-' + w.code">Entiendo y confirmo</label>
        </div>
      </div>
    </div>

    <!-- El motivo se pide aquí, con el impacto a la vista -->
    <div class="field ea-reason">
      <label for="ea-reason">Motivo del cambio</label>
      <textarea
        id="ea-reason"
        pInputTextarea
        [(ngModel)]="reason"
        rows="3"
        [maxlength]="500"
        placeholder="Describe por qué se ajustan los montos (queda en la bitácora del arrendamiento)"
      ></textarea>
      <small class="p-error" *ngIf="!reason.trim()">El motivo es obligatorio para poder guardar.</small>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <!-- Confirmación EN LÍNEA al descartar: un confirm() nativo bloquea la página entera -->
    <ng-container *ngIf="confirmingClose; else footerNormal">
      <span class="ea-discard-msg"><i class="pi pi-exclamation-triangle"></i> Se perderá lo capturado. ¿Cerrar de todos modos?</span>
      <button pButton type="button" label="Seguir editando" class="p-button-text" (click)="cancelClose()"></button>
      <button pButton type="button" label="Sí, cerrar" icon="pi pi-times" class="p-button-danger" (click)="hide()"></button>
    </ng-container>
    <ng-template #footerNormal>
      <button pButton type="button" label="Cancelar" class="p-button-text" (click)="requestHide()" [disabled]="saving"></button>
      <button
        pButton
        type="button"
        label="Volver a editar"
        icon="fa-solid fa-arrow-left"
        class="p-button-text"
        *ngIf="preview"
        (click)="invalidatePreview()"
        [disabled]="saving"
      ></button>
      <button
        pButton
        type="button"
        label="Aplicar cambios"
        icon="pi pi-check"
        (click)="apply()"
        [disabled]="!canApply"
        [loading]="saving"
        [pTooltip]="
          !preview
            ? 'Primero previsualiza el impacto'
            : !reason.trim()
              ? 'Captura el motivo'
              : !allWarningsConfirmed
                ? 'Faltan advertencias por confirmar'
                : ''
        "
        tooltipPosition="top"
      ></button>
    </ng-template>
  </ng-template>
</p-dialog>
